export default (value, currencyCode) => {
  return value.toLocaleString('fr-FR', { style: 'currency', currency: currencyCode })
}
